import React, { FC, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { AddOUFormData } from "./validation.schema";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid2";

type TabOrganizationAddressProps = {
  editMode?: boolean;
};

export const TabOrganizationAddress: FC<TabOrganizationAddressProps> = ({
  editMode = false,
}) => {
  const { t } = useTranslation("organization");

  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<AddOUFormData>();

  return (
    <Grid container spacing={"20px"}>
      <Grid size={12}>
        <Controller
          name="addressLine1"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              id="addressLine1"
              label={t("modals.label-address-1")}
              variant="outlined"
              required
              value={field.value}
              onChange={(value) => field.onChange(value)}
              error={!!errors.addressLine1}
              helperText={
                errors.addressLine1 ? errors.addressLine1.message : null
              }
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid size={6}>
        <Controller
          name="addressLine2"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              id="addressLine2"
              label={t("modals.label-address-2")}
              variant="outlined"
              value={field.value}
              onChange={(value) => field.onChange(value)}
              error={!!errors.addressLine2}
              helperText={
                errors.addressLine2 ? errors.addressLine2.message : null
              }
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid size={6}>
        <Controller
          name="city"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              id="city"
              label={t("modals.label-city")}
              required
              variant="outlined"
              value={field.value}
              onChange={(value) => field.onChange(value)}
              error={!!errors.city}
              helperText={errors.city ? errors.city.message : null}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid size={6}>
        <Controller
          name="region"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              id="region"
              label={t("modals.label-region")}
              required
              variant="outlined"
              value={field.value}
              onChange={(value) => field.onChange(value)}
              error={!!errors.region}
              helperText={errors.region ? errors.region.message : null}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid size={6}>
        <Controller
          name="zipCode"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              id="zipCode"
              label={t("modals.label-zip-code")}
              required
              variant="outlined"
              value={field.value}
              onChange={(value) => field.onChange(value)}
              error={!!errors.zipCode}
              helperText={errors.zipCode ? errors.zipCode.message : null}
              fullWidth
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
